/* eslint-disable react/no-unescaped-entities */
import { Button } from '@mui/material';
import { useRequest } from 'ahooks';
import classNames from 'classnames';
import Decimal from 'decimal.js';
import { useAtom, useAtomValue } from 'jotai';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { implog } from '@/api/implog';
import { getJackpotAward } from '@/api/jackpot';
import { ReactComponent as JackpotHelpIcon } from '@/assets/jackpot/help.svg';
import { ReactComponent as WithdrawHistory } from '@/assets/jackpot/withdraw_history.svg';
import showNiceModal from '@/components/nice-modal';
import BlurryLoadingImage from '@/components/progressive-img';
import Wheel from '@/components/wheel-number';
import { emitterAtom } from '@/jotai/emitter';
import { jackpotAtom, jackpotHeartbeatAtom, jackpotRetarirAtom, jackpotSpinAtom } from '@/jotai/jackpot';
import { modalStore } from '@/stores/modal';
import { globalStore } from '@/stores/store';
import { resolveImgPath } from '@/utils/img';
import Storage from '@/utils/Storage';
import { toast } from '@/utils/toast';

import JackpotHelp from './help';
import JackpotRecord from './record/jackpot';
import JackpotSwiper from './record/swiper';
import styles from './style.module.less';

function formatNumberToSevenChars(num) {
  // 将数字保留两位小数并转换为字符串
  let numStr = num.toFixed(2).replace('.', '');

  // 如果字符串长度小于7，则在前面补零
  while (numStr.length < 7) {
    numStr = '0' + numStr;
  }

  // 只保留前7个字符
  return numStr.substring(0, 7);
}
const App: React.FC = () => {
  const { initialState } = globalStore;
  const { vippoint } = initialState;
  const emitter = useAtomValue(emitterAtom);

  const navigate = useNavigate();
  const [userInfo, setJackpot] = useAtom(jackpotAtom);
  const jackpotHeartbeat = useAtomValue(jackpotHeartbeatAtom);
  const canSpin = useAtomValue(jackpotSpinAtom);
  const canRetarir = useAtomValue(jackpotRetarirAtom);
  const [awardLoading, setAwardLoading] = useState(false);
  const [awardDisabled, setAwardDisabled] = useState(false);
  const cacheAward = Storage.get('cache-jackpot-award');
  const [award, setAward] = useState(cacheAward || '???????');

  const { runAsync: getAward } = useRequest(getJackpotAward, {
    manual: true,
    onSuccess: res => {
      const newAward = formatNumberToSevenChars(res?.gain || 0);
      setAward(newAward);
      Storage.set('cache-jackpot-award', newAward);
      setJackpot({
        ...userInfo,
        score: res?.info?.score,
        score_exp: res?.info?.score_exp
      });
      setAwardLoading(false);
      setTimeout(() => {
        setAwardDisabled(false);
        emitter.emit({ type: 'jpinfo_update' });
      }, 7000);
    },
    onError: () => {
      setAwardLoading(false);
      setTimeout(() => {
        emitter.emit({ type: 'jpinfo_update' });
        setAwardDisabled(false);
      }, 7000);
    }
  });
  useEffect(() => {
    implog('jp_modal_show');
  }, []);

  return (
    <div className={styles.jackpot}>
      <div className={styles.jackpot_record}>
        <div
          className={styles.record_withdraw}
          data-testid="jackpot-retirar-btn"
          onClick={async () => {
            implog('jp_retirar_click');
            if (vippoint <= 0) {
              modalStore.openFirstRecharge();
              return;
            }
            navigate('/jackpot/withdraw');
          }}
        >
          <div className={styles.record_withdraw_progress}>
            $ {userInfo?.gold || 0} <span>/ 30</span>
          </div>
          <div
            className={classNames(
              styles.record_withdraw_submit,
              canRetarir && vippoint > 0 ? styles.active : styles.disabled
            )}
          ></div>
        </div>
        {/* <BlurryLoadingImage
          loading="lazy"
          title="ℹ️"
          className={styles.record_history}
          src={(window?.imgPrefix || '') + '/img/jackpot/withdraw_history.webp'}
          style={{ width: '0.72rem', height: '0.65rem' }}
          alt="ℹ️"
          data-testid="jackpot-retirar-record"
          onClick={() => {
            showNiceModal(
              {
                maskClosable: true,
                width: '6.6rem',
                contentStyle: {
                  background: 'var(--backgroundColor)',
                  boxShadow: '0px 2px 2px 0px var(--secondaryColor)',
                  borderRadius: '.12rem',
                  paddingBottom: '1rem'
                },
                render: JackpotRecord
              },
              'jackpot-record-modal'
            );
          }}
        /> */}
        <WithdrawHistory
          className={styles.record_history}
          style={{ width: '0.72rem', height: '0.65rem', color: 'var(--secondaryColor)' }}
          data-testid="jackpot-retirar-record"
          onClick={() => {
            showNiceModal(
              {
                maskClosable: true,
                width: '6.6rem',
                contentStyle: {
                  background: 'var(--backgroundColor)',
                  boxShadow: '0px 2px 2px 0px var(--secondaryColor)',
                  borderRadius: '.12rem',
                  paddingBottom: '1rem'
                },
                render: JackpotRecord
              },
              'jackpot-record-modal'
            );
          }}
        />
      </div>
      <div className={styles.jackpot_content}>
        <BlurryLoadingImage
          className={styles.jackpot_content_bg}
          src={`${window?.imgPrefix || ''}/img/jackpot/jackpot_content_bg.webp`}
          loading="lazy"
          alt=""
        />
        <div style={{ height: '2.5rem', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <BlurryLoadingImage
            className={styles.jackpot_content_title}
            src={`${window?.imgPrefix || ''}/img/jackpot/jackpot_content_title.webp`}
            loading="lazy"
            style={{
              width: '4.56rem',
              height: '1.01rem'
            }}
            alt=""
          />
          <div className={styles.jackpot_content_total} style={{ minHeight: '40px' }}>
            $
            {String(jackpotHeartbeat)
              .split('')
              .map((digit, index) =>
                digit === '.' ? (
                  '.'
                ) : (
                  <Wheel
                    key={`total-${index}`}
                    width="fit-content"
                    value={digit}
                    delay={(7 - index) * 100}
                    duration={1000}
                    height={40}
                    className={styles.wheel_item}
                  />
                )
              )}
          </div>
        </div>
        <div className={styles.jackpot_content_lunpan}>
          <BlurryLoadingImage
            style={{
              width: '6.25rem',
              height: '2.85rem'
            }}
            src={resolveImgPath('jackpot/jackpot_content_lunpan.webp')}
            loading="lazy"
            alt=""
          />
          <div className={styles.jackpot_content_lunpan_title}>
            {award.split('').map((digit, index) => (
              <Wheel
                key={`lunpan-${index}`}
                width="fit-content"
                value={digit}
                delay={(7 - index) * 100}
                duration={1000}
                height={80}
                loading={awardLoading}
                className={styles.lunpan_wheel_item}
              />
            ))}
          </div>
          <div className={styles.jackpot_content_lunpan_btn}>
            <div
              className={styles.lunpan_retirar_btn}
              data-testid="jackpot-gain-award-btn"
              onClick={() => {
                if (awardLoading || awardDisabled) return;
                implog('jp_spin_click');
                if (vippoint <= 0 || !canSpin) {
                  showNiceModal(
                    {
                      closable: {
                        hideClose: true
                      },
                      maskClosable: true,
                      width: '6.8rem',
                      contentStyle: {
                        background: 'rgba(0,0,0,0.85)',
                        borderRadius: '0.1rem'
                      },
                      hideBackdrop: true,
                      render: JackpotHelp
                    },
                    'jackpot-content-help-modal'
                  );
                  return;
                }
                if (canSpin) {
                  setAwardLoading(true);
                  setAwardDisabled(true);
                  getAward();
                }
              }}
            >
              <div className={styles.lunpan_retirar_spin}>
                <div
                  className={classNames(styles.activity_retirar_spin_btn, canSpin ? styles.active : '')}
                  style={{
                    width:
                      !(awardDisabled || awardLoading) && vippoint > 0
                        ? `${Math.max(
                            Decimal.div(userInfo?.score || 0, userInfo?.score_exp || 1)
                              .mul(100)
                              .toNumber(),
                            15
                          )}%`
                        : '0%'
                  }}
                ></div>
              </div>
            </div>

            <JackpotHelpIcon
              style={{
                width: '0.49rem',
                height: '0.49rem'
              }}
              onClick={() => {
                showNiceModal(
                  {
                    closable: {
                      hideClose: true
                    },
                    maskClosable: true,
                    width: '6.8rem',
                    contentStyle: {
                      background: 'rgba(0,0,0,0.85)',
                      borderRadius: '0.1rem'
                    },
                    hideBackdrop: true,
                    render: JackpotHelp
                  },
                  'jackpot-content-help-modal'
                );
              }}
              className={styles.jackpot_content_lunpan_btn_help}
            />

            {/* <BlurryLoadingImage
              style={{
                width: '0.49rem',
                height: '0.49rem'
              }}
              width="25px"
              height="25px"
              src={resolveImgPath('jackpot/help.webp')}
              loading="lazy"
              alt=""
              onClick={() => {
                showNiceModal(
                  {
                    closable: {
                      hideClose: true
                    },
                    maskClosable: true,
                    width: '6.8rem',
                    contentStyle: {
                      background: 'rgba(0,0,0,0.85)',
                      borderRadius: '0.1rem'
                    },
                    hideBackdrop: true,
                    render: JackpotHelp
                  },
                  'jackpot-content-help-modal'
                );
              }}
              className={styles.jackpot_content_lunpan_btn_help}
            /> */}
          </div>
          <div className={styles.jackpot_content_lunpan_tips}>
            {vippoint > 0 ? (
              <div
                style={{
                  lineHeight: '0.48rem',
                  whiteSpace: 'unset'
                }}
              >
                Bet{' '}
                <span>
                  {userInfo?.score?.toFixed(2) || 0}/{userInfo?.score_exp || 0}
                </span>{' '}
                today to hit the JACKPOT The maximum bonus available is $99,999.99. <br /> Lottery conditions reset at
                0:00 every day.
              </div>
            ) : (
              <div>
                Only VIPs can win the free JACKPOT <br /> every day. The maximum bonus available <br /> is $99,999.99.
                <br />
                <Button
                  sx={{
                    width: '2.2rem',
                    height: '0.6rem',
                    fontSize: '0.28rem',
                    borderRadius: '0.3rem',
                    marginTop: '0.1rem',
                    textTransform: 'none'
                  }}
                  className="global_button_succes"
                  data-testid="jackpot-recharga-btn"
                  onClick={async () => {
                    implog('jp_recharga_click');
                    modalStore.openFirstRecharge();
                  }}
                >
                  Deposit
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={styles.jackpot_footer}>
        <JackpotSwiper />
      </div>
    </div>
  );
};

export default App;
